import { TaskStatus } from "../../types/status";

const statusStyles: Record<TaskStatus, string> = {
  [TaskStatus.PENDING]: "bg-yellow-500/20 text-yellow-300",
  [TaskStatus.RUNNING]: "bg-blue-500/20 text-blue-200",
  [TaskStatus.PROCESSING]: "bg-blue-500/20 text-blue-200",
  [TaskStatus.COMPLETED]: "bg-emerald-500/20 text-emerald-300",
  [TaskStatus.FAILED]: "bg-red-500/20 text-red-300",
  [TaskStatus.DRAFT]: "bg-gray-500/20 text-[var(--text-secondary)]"
};

interface Props {
  status: TaskStatus;
}

const StatusBadge: React.FC<Props> = ({ status }) => {
  return <span className={`rounded-full px-3 py-1 text-xs font-semibold ${statusStyles[status]}`}>{status}</span>;
};

export default StatusBadge;
